const COUNTRY_INSIGHT_SLUG_TO_CODE = {
  albania: "alb",
  austria: "at",
  belgium: "be",
  bulgaria: "bg",
  croatia: "hr",
  cyprus: "cy",
  "czech-republic": "cz",
  denmark: "dk",
  estonia: "ee",
  finland: "fi",
  france: "fr",
  germany: "de",
  greece: "gr",
  hungary: "hu",
  iceland: "is",
  ireland: "ie",
  italy: "it",
  latvia: "lv",
  liechtenstein: "li",
  lithuania: "lt",
  luxembourg: "lu",
  malta: "mt",
  moldova: "md",
  montenegro: "me",
  netherlands: "nl",
  norway: "no",
  poland: "pl",
  portugal: "pt",
  romania: "ro",
  serbia: "rs",
  slovakia: "sk",
  slovenia: "si",
  spain: "es",
  sweden: "se",
  switzerland: "ch",
  ukraine: "ua",
  "united-kingdom": "gb",
};

export function normalizeEditorialThumbnail(thumbnail) {
  if (!thumbnail || typeof thumbnail !== "string") {
    return "";
  }
  const cleaned = thumbnail.replace(/^https:\/\/drupal\.agiledrop\.svc/, "");
  if (/^https?:\/\//.test(cleaned)) {
    return cleaned;
  }
  return `https://data.europa.eu${cleaned}`;
}

export function getCountryInsightSlug(path) {
  if (!path) {
    return "";
  }
  const cleanPath = String(path).split("?")[0].replace(/\/$/, "");
  return cleanPath.substring(cleanPath.lastIndexOf("/") + 1).toLowerCase();
}

export function getCountryInsightCode(item) {
  if (!item) {
    return "";
  }
  const path = item.path || "";
  const contentType = item.content_type || "";
  const isCountryInsight = contentType === "country_insight" || path.includes("/country-insights/");
  if (!isCountryInsight) {
    return "";
  }
  const slug = getCountryInsightSlug(path);
  return COUNTRY_INSIGHT_SLUG_TO_CODE[slug] || "";
}

export function getEditorialThumbnailOrFlag(item, getCountryFlagImg) {
  const normalizedThumbnail = normalizeEditorialThumbnail(item?.thumbnail);
  if (normalizedThumbnail) {
    return normalizedThumbnail;
  }
  const countryCode = getCountryInsightCode(item);
  if (!countryCode) {
    return "";
  }
  return getCountryFlagImg(countryCode);
}
